import { EmissionResume } from 'src/models/emission/EmissionResume';
import { VinChangeData } from 'src/models/emission/VinChangeData';

export const makeInitialValues = (emission: EmissionResume): VinChangeData => ({
  vinNumber: emission.vinNumber,
  invoiceName: emission.invoiceName,
  invoiceBase64: emission.invoiceBase64,
});

export default makeInitialValues;
